<template>
  <div class="materiales-page">
    <!-- Header -->
    <div class="mat-header">
      <div>
        <span class="header-eyebrow">Inventario</span>
        <h2 class="header-title">Materiales</h2>
      </div>
      <div class="header-actions">
        <button class="btn-mat btn-mat--ghost" @click="imgTable = !imgTable">
          <i :class="imgTable ? 'fa-solid fa-camera' : 'fa-solid fa-camera-slash'"></i>
          {{ imgTable ? 'Ocultar imagenes' : 'Ver imagenes' }}
        </button>
        <button class="btn-mat btn-mat--ghost" :class="{ 'btn-mat--active': showRelaciones }" @click="toggleRelaciones">
          <i class="fa-solid fa-link"></i>
          Relaciones
        </button>
        <button class="btn-mat btn-mat--primary" @click="toggleFormulario">
          <i :class="showForm ? 'fa-solid fa-xmark' : 'fa-solid fa-plus'"></i>
          {{ showForm ? 'Cerrar' : 'Nuevo material' }}
        </button>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Total</span>
        <span class="kpi-value">{{ listMateriales.length }}</span>
        <span class="kpi-foot">materiales</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Categorias</span>
        <span class="kpi-value">{{ categoriasUsadas }}</span>
        <span class="kpi-foot">distintas</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Proveedores</span>
        <span class="kpi-value">{{ proveedoresUsados }}</span>
        <span class="kpi-foot">vinculados</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Mostrando</span>
        <span class="kpi-value">{{ linesTable.length }}</span>
        <span class="kpi-foot">resultados</span>
      </div>
    </div>

    <!-- Formulario crear/editar -->
    <transition name="slide">
      <div class="form-card" v-if="showForm">
        <div class="form-card__header">
          <div class="form-card__icon" :class="materialSelected ? 'form-card__icon--warning' : 'form-card__icon--primary'">
            <i :class="materialSelected ? 'fa-solid fa-pen' : 'fa-solid fa-plus'"></i>
          </div>
          <div>
            <h3 class="form-card__title">{{ materialSelected ? 'Editar material' : 'Nuevo material' }}</h3>
            <p class="form-card__subtitle" v-if="materialSelected">Editando: {{ materialSelected.nombre }}</p>
            <p class="form-card__subtitle" v-else-if="materialDuplicado">Copia de: {{ materialDuplicado.nombre }}</p>
          </div>
        </div>

        <div class="form-grid">
          <div class="field field--span2">
            <label class="field__label">Nombre</label>
            <b-form-input size="sm" placeholder="Nombre del material" v-model="nombre" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Material</label>
            <b-form-input size="sm" placeholder="Tipo de material" v-model="material" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Color</label>
            <b-form-input size="sm" placeholder="Color" v-model="color" class="field__input" />
          </div>

          <div class="field">
            <label class="field__label">Tipo medidas</label>
            <v-select v-model="tipoMedidas" :options="listTipoMedidas" class="select-styled" />
          </div>
          <div class="field">
            <label class="field__label">Medidas</label>
            <b-form-input size="sm" placeholder="Medidas" v-model="medidas" class="field__input" :disabled="tipoMedidas === 'Unidades'" />
          </div>
          <div class="field">
            <label class="field__label">Precio</label>
            <b-form-input size="sm" placeholder="0.00" v-model="precio" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Categoria</label>
            <v-select v-model="categoria" :options="listCategorias" class="select-styled" />
          </div>

          <div class="field">
            <label class="field__label">EAN</label>
            <b-form-input size="sm" placeholder="Codigo EAN" v-model="ean" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Ref. Proveedor</label>
            <b-form-input size="sm" placeholder="Referencia" v-model="ref" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Stock</label>
            <b-form-input size="sm" type="number" step="any" placeholder="0" v-model="stock" class="field__input" :disabled="tieneUnidades(materialSelected)" @wheel.native.prevent />
            <small v-if="tieneUnidades(materialSelected)" class="field__hint">Se gestiona desde Almacén</small>
          </div>
          <div class="field">
            <label class="field__label">Proveedor</label>
            <v-select v-model="proveedorSelect" label="nombre" :options="listProveedores" class="select-styled" />
          </div>

          <div class="field field--span3">
            <label class="field__label">Notas</label>
            <b-form-textarea placeholder="Notas sobre el material..." rows="2" v-model="nota" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Imagen</label>
            <label class="upload-area" :class="{ 'upload-area--con-img': new_img_preview }">
              <b-form-file v-model="new_img" accept="image/*" plain class="upload-area__input"></b-form-file>
              <img v-if="new_img_preview" :src="new_img_preview" class="upload-area__preview" />
              <div v-else class="upload-area__placeholder">
                <i class="fa-solid fa-cloud-arrow-up"></i>
                <span>Subir imagen</span>
              </div>
            </label>
            <button v-if="new_img_preview" type="button" class="upload-crop" @click="abrirRecorte()">
              <i class="fa-solid fa-crop-simple"></i> Recortar
            </button>
          </div>
        </div>

        <!-- Calculadora (solo para medidas no unitarias) -->
        <div class="calc-bar" v-if="tipoMedidas !== 'Unidades'">
          <div class="calc-bar__label">
            <i class="fa-solid fa-calculator"></i> Calculadora
          </div>
          <div class="calc-bar__fields">
            <div class="field">
              <label class="field__label">{{ tipoMedidas === 'Metro lineal' ? 'Largo' : 'Ancho' }} <span class="calc-bar__unit" v-if="unidadCalc">({{ unidadCalc }})</span></label>
              <b-form-input size="sm" placeholder="0" v-model="anchoCalc" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">{{ tipoMedidas === 'Metro lineal' ? 'Ancho' : 'Alto' }} <span class="calc-bar__unit" v-if="unidadCalc">({{ tipoMedidas === 'Metro lineal' ? 'pon 1' : unidadCalc }})</span></label>
              <b-form-input size="sm" placeholder="0" v-model="altoCalc" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">Precio total <span class="calc-bar__unit">(€ pieza)</span></label>
              <b-form-input size="sm" placeholder="0.00" v-model="precioCalc" class="field__input" />
            </div>
            <span class="calc-bar__result" v-if="resultadoCalc">
              = {{ resultadoCalc.medidas }} medidas · {{ resultadoCalc.precio }} €
            </span>
            <button class="btn-mat btn-mat--primary" :disabled="!resultadoCalc" @click="calcular()" title="Pasar el resultado a Medidas y Precio">
              <i class="fa-solid fa-arrow-up"></i> Aplicar
            </button>
          </div>
        </div>
        <p class="calc-note" v-if="tipoMedidas !== 'Unidades'">
          <i class="fa-solid fa-circle-info"></i>
          <span v-if="notaCalc" v-html="notaCalc"></span>
          <span v-else>Elige primero el <strong>tipo de medidas</strong> para saber en que unidad poner ancho y alto.</span>
        </p>

        <div class="form-card__footer">
          <button v-if="materialSelected" class="btn-mat btn-mat--ghost" @click="limpiarFormulario()">
            Cancelar edicion
          </button>
          <button
            class="btn-mat"
            :class="materialSelected ? 'btn-mat--warning' : 'btn-mat--primary'"
            @click="guardarMaterial()"
          >
            <i :class="materialSelected ? 'fa-solid fa-check' : 'fa-solid fa-plus'"></i>
            {{ materialSelected ? 'Actualizar' : 'Crear material' }}
          </button>
        </div>
      </div>
    </transition>

    <!-- Relaciones material / producto -->
    <transition name="slide">
      <div class="form-card form-card--rel" v-if="showRelaciones">
        <div class="form-card__header">
          <div class="form-card__icon form-card__icon--primary">
            <i class="fa-solid fa-link"></i>
          </div>
          <div>
            <h3 class="form-card__title">Relaciones material / producto</h3>
            <p class="form-card__subtitle" v-if="relDesdeTabla">Relaciona este material con los productos que lo usan</p>
            <p class="form-card__subtitle" v-else>Selecciona un material para ver sus productos, o un producto para ver sus materiales</p>
          </div>
        </div>

        <div class="form-grid form-grid--rel" v-if="!relDesdeTabla">
          <div class="field field--span2" v-show="!relProductoSelect">
            <label class="field__label"><i class="fa-solid fa-cube"></i> Material</label>
            <v-select
              v-model="relMaterialSelect"
              label="nombre"
              :options="listMateriales"
              placeholder="Selecciona un material..."
              class="select-styled"
            />
          </div>
          <div class="field field--span2" v-show="!relMaterialSelect">
            <label class="field__label"><i class="fa-solid fa-shirt"></i> Producto</label>
            <v-select
              v-model="relProductoSelect"
              :options="listProductosTitulos"
              placeholder="Selecciona un producto..."
              class="select-styled"
            />
          </div>
        </div>

        <!-- Vista por material -->
        <div class="rel-body" v-if="relMaterialSelect">
          <div class="rel-body__title">
            Productos que usan <strong>{{ relMaterialSelect.nombre }}</strong>
            <span class="rel-count">{{ productosDelMaterial.length }}</span>
            <button class="rel-close" v-if="relDesdeTabla" @click="cerrarRelaciones()" title="Cerrar">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div class="rel-add" v-if="relDesdeTabla">
            <v-select
              v-model="addProductoSelect"
              :options="productosDisponibles"
              placeholder="Añadir producto..."
              class="select-styled rel-add__select"
              @input="focusCantidadRel"
            />
            <div class="rel-add__qty" v-if="addProductoSelect">
              <input
                ref="inputCantidadRel"
                type="number"
                class="rel-add__qty-input"
                v-model="addCantidad"
                placeholder="Cantidad"
                @wheel.prevent
                @keyup.enter="asociarRelacion()"
              />
              <span class="rel-add__unit">{{ relMaterialSelect.tipoMedidas }}</span>
            </div>
            <span class="rel-add__hint" v-if="addProductoSelect">
              Se añade a sus {{ (skusPorTitle[addProductoSelect] || []).length }} SKUs
            </span>
            <button class="btn-mat btn-mat--primary" :disabled="!addProductoSelect || !addCantidad" @click="asociarRelacion()">
              <i class="fa-solid fa-plus"></i> Asociar
            </button>
          </div>

          <div class="rel-grid" v-if="productosDelMaterial.length">
            <div class="rel-card" v-for="rel in productosDelMaterial" :key="rel.id">
              <img v-if="mapProductoImg[rel.tituloProducto]" :src="mapProductoImg[rel.tituloProducto]" class="rel-card__img" />
              <div v-else class="rel-card__img rel-card__img--empty"><i class="fa-solid fa-image"></i></div>
              <div class="rel-card__info">
                <span class="rel-card__title">{{ rel.tituloProducto }}</span>
                <span class="rel-card__sub">{{ textoRelacion(rel) }}</span>
              </div>
              <button class="rel-chip__remove" v-if="relDesdeTabla" @click="eliminarRelacion(rel)" title="Quitar">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
          <p class="rel-empty" v-else>Este material no esta asociado a ningun producto todavia.</p>
        </div>

        <!-- Vista por producto -->
        <div class="rel-body" v-if="relProductoSelect">
          <div class="rel-body__title">
            Materiales de <strong>{{ relProductoSelect }}</strong>
            <span class="rel-count">{{ materialesDelProductoInfo.length }}</span>
          </div>

          <div class="rel-grid" v-if="materialesDelProductoInfo.length">
            <div
              class="rel-card rel-card--clickable"
              v-for="item in materialesDelProductoInfo"
              :key="item.rel.id"
              @click="verInformacion(item.mat)"
            >
              <img v-if="imgTable && item.mat.img" :src="item.mat.img" class="rel-card__img" />
              <div v-else-if="imgTable" class="rel-card__img rel-card__img--empty"><i class="fa-solid fa-cube"></i></div>
              <div class="rel-card__info">
                <span class="rel-card__title">{{ item.mat.nombre }}</span>
                <span class="rel-card__sub">
                  {{ [item.mat.material, item.mat.color].filter(Boolean).join(' · ') || 'Material' }}
                </span>
                <span class="rel-card__sub">{{ textoRelacion(item.rel) }}</span>
              </div>
              <span class="badge-cat" v-if="item.mat.categoria">{{ item.mat.categoria }}</span>
            </div>
          </div>
          <p class="rel-empty" v-else>Este producto no tiene materiales asociados todavia.</p>
        </div>
      </div>
    </transition>

    <!-- Listado -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Listado de materiales</h3>
        <div class="list-card__filters">
          <div class="filter-group">
            <label class="filter-label">Categoria</label>
            <v-select
              v-model="categoriaSeleccionada"
              :options="listCategorias"
              placeholder="Todas"
              class="select-styled select-filter"
            />
          </div>
          <div class="search-box">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input
              type="text"
              class="search-box__input"
              placeholder="Buscar material..."
              v-model="buscar"
            />
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="linesTable"
          :fields="columnasTable"
          class="mb-0"
          hover
          responsive
          show-empty
          empty-text="No se encontraron materiales"
          sort-icon-left
          thead-class="table-head"
          tbody-tr-class="table-row"
        >
          <template #cell(editar)="data">
            <button class="action-btn action-btn--edit" @click="editarProveedor(data.item)" title="Editar">
              <i class="fa-solid fa-pen"></i>
            </button>
          </template>

          <template #cell(img)="data">
            <img v-if="data.item.img" :src="data.item.img" class="cell-img" />
            <div v-else class="cell-img-empty">
              <i class="fa-solid fa-image"></i>
            </div>
          </template>

          <template #cell(nombre)="data">
            <div class="cell-nombre">
              <span class="cell-nombre__name">{{ data.item.nombre }}</span>
              <span class="cell-nombre__material" v-if="data.item.material">{{ data.item.material }}</span>
            </div>
          </template>

          <template #cell(color)="data">
            <span class="cell-text" v-if="data.item.color">{{ data.item.color }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(precio)="data">
            <span class="cell-mono" v-if="data.item.precio">{{ data.item.precio }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(stock)="data">
            <span class="cell-mono" :class="{ 'cell-stock--empty': stockNum(data.item) <= 0 }">{{ stockNum(data.item) }}</span>
          </template>

          <template #cell(categoria)="data">
            <span class="badge-cat" v-if="data.item.categoria">{{ data.item.categoria }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(proveedor)="data">
            <span class="cell-text" v-if="data.item.proveedor">{{ data.item.proveedor }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(acciones)="data">
            <div class="cell-actions">
              <button class="action-btn action-btn--view" @click="verInformacion(data.item)" title="Ver detalle">
                <i class="fa-solid fa-eye"></i>
              </button>
              <button
                class="action-btn action-btn--stock"
                :disabled="tieneUnidades(data.item)"
                @click="abrirAgregarStock(data.item)"
                :title="tieneUnidades(data.item) ? 'Stock gestionado desde Almacén' : 'Agregar stock'"
              >
                <i class="fa-solid fa-boxes-stacked"></i>
              </button>
              <button class="action-btn action-btn--copy" @click="duplicarMaterial(data.item)" title="Duplicar">
                <i class="fa-solid fa-clone"></i>
              </button>
              <button class="action-btn action-btn--link" @click="verRelaciones(data.item)" title="Productos relacionados">
                <i class="fa-solid fa-link"></i>
              </button>
              <button class="action-btn action-btn--delete" @click="confirmText(data.item)" title="Eliminar">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ linesTable.length }} materiales</span>
      </div>
    </div>

    <!-- Modal detalle -->
    <b-modal
      ref="modal-ver-material"
      modal-class="modal-mat"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <div class="modal-custom">
        <div class="modal-custom__header">
          <div class="modal-custom__icon modal-custom__icon--primary">
            <i class="fa-solid fa-cube"></i>
          </div>
          <h4 class="modal-custom__title">{{ itemInfo.nombre }}</h4>
          <p class="modal-custom__subtitle" v-if="itemInfo.material">{{ itemInfo.material }}</p>
        </div>

        <div class="modal-custom__body">
          <!-- Imagen -->
          <div class="modal-img" v-if="itemInfo.img">
            <img :src="itemInfo.img" class="modal-img__image" />
            <button type="button" class="upload-crop upload-crop--floating" @click="recortarGuardada(itemInfo)">
              <i class="fa-solid fa-crop-simple"></i> Recortar
            </button>
          </div>

          <div class="detail-grid">
            <div class="detail-item" v-if="itemInfo.color">
              <span class="detail-item__icon"><i class="fa-solid fa-palette"></i></span>
              <div>
                <span class="detail-item__label">Color</span>
                <span class="detail-item__value">{{ itemInfo.color }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.precio">
              <span class="detail-item__icon"><i class="fa-solid fa-tag"></i></span>
              <div>
                <span class="detail-item__label">Precio</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.precio }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.tipoMedidas">
              <span class="detail-item__icon"><i class="fa-solid fa-ruler"></i></span>
              <div>
                <span class="detail-item__label">Medidas</span>
                <span class="detail-item__value">{{ itemInfo.medidas }} ({{ itemInfo.tipoMedidas }})</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.categoria">
              <span class="detail-item__icon"><i class="fa-solid fa-folder"></i></span>
              <div>
                <span class="detail-item__label">Categoria</span>
                <span class="detail-item__value">{{ itemInfo.categoria }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.ean">
              <span class="detail-item__icon"><i class="fa-solid fa-barcode"></i></span>
              <div>
                <span class="detail-item__label">EAN</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.ean }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.ref">
              <span class="detail-item__icon"><i class="fa-solid fa-hashtag"></i></span>
              <div>
                <span class="detail-item__label">Ref. Proveedor</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.ref }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.proveedor">
              <span class="detail-item__icon"><i class="fa-solid fa-truck"></i></span>
              <div>
                <span class="detail-item__label">Proveedor</span>
                <span class="detail-item__value">{{ itemInfo.proveedor }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.emailProveedor">
              <span class="detail-item__icon"><i class="fa-solid fa-envelope"></i></span>
              <div>
                <span class="detail-item__label">Email proveedor</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.emailProveedor }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="productosDeMaterial(itemInfo).length">
              <span class="detail-item__icon"><i class="fa-solid fa-link"></i></span>
              <div>
                <span class="detail-item__label">Productos</span>
                <span class="detail-item__value">
                  <span class="modal-prod" v-for="rel in productosDeMaterial(itemInfo)" :key="rel.id">
                    <img v-if="mapProductoImg[rel.tituloProducto]" :src="mapProductoImg[rel.tituloProducto]" class="modal-prod__img" />
                    <span v-else class="modal-prod__img modal-prod__img--empty"><i class="fa-solid fa-image"></i></span>
                    <span class="modal-prod__title">{{ rel.tituloProducto }}</span>
                  </span>
                </span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.nota">
              <span class="detail-item__icon"><i class="fa-solid fa-note-sticky"></i></span>
              <div>
                <span class="detail-item__label">Notas</span>
                <span class="detail-item__value">{{ itemInfo.nota }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-custom__footer">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-ver-material'].hide()">Cerrar</button>
          <button class="btn-modal btn-modal--primary" @click="$refs['modal-ver-material'].hide(); editarProveedor(itemInfo)">
            <i class="fa-solid fa-pen"></i> Editar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal agregar stock -->
    <b-modal
      ref="modal-agregar-stock"
      modal-class="modal-mat"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <div class="modal-custom">
        <div class="modal-custom__header">
          <div class="modal-custom__icon modal-custom__icon--primary">
            <i class="fa-solid fa-boxes-stacked"></i>
          </div>
          <h4 class="modal-custom__title">Agregar stock</h4>
          <p class="modal-custom__subtitle" v-if="stockItem">
            {{ stockItem.nombre }}<span v-if="stockItem.color"> · {{ stockItem.color }}</span>
          </p>
        </div>

        <div class="modal-custom__body" v-if="stockItem">
          <div class="stock-summary">
            <div class="stock-summary__col">
              <span class="detail-item__label">Actual</span>
              <span class="stock-summary__value">{{ stockNum(stockItem) }}</span>
            </div>
            <i class="fa-solid fa-plus stock-summary__op"></i>
            <div class="stock-summary__col">
              <span class="detail-item__label">Cantidad</span>
              <b-form-input
                type="number"
                size="sm"
                step="any"
                v-model="stockCantidad"
                class="stock-summary__input"
                @wheel.native.prevent
                @keyup.enter="guardarAgregarStock()"
              />
            </div>
            <i class="fa-solid fa-equals stock-summary__op"></i>
            <div class="stock-summary__col">
              <span class="detail-item__label">Nuevo</span>
              <span class="stock-summary__value stock-summary__value--new">{{ stockNuevo }}</span>
            </div>
          </div>
        </div>

        <div class="modal-custom__footer">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-agregar-stock'].hide()">Cancelar</button>
          <button class="btn-modal btn-modal--primary" :disabled="!stockCantidadValida || guardandoStock" @click="guardarAgregarStock()">
            <i class="fa-solid fa-check"></i> Agregar
          </button>
        </div>
      </div>
    </b-modal>

    <image-cropper
      ref="cropper"
      @cropped="recortado"
      @error="$bvToast.toast('No se ha podido recortar la imagen', { title: 'Error', variant: 'danger', solid: true })"
    />
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import ImageCropper from '@/components/ImageCropper.vue'
import { prepararSinImagen, cargarImagenesMateriales } from '@/utils/materialesImagenes'

export default {
  components: {
    vSelect,
    ImageCropper,
  },
  data(){
    return{
      nombre: "",
      tipoMedidas: "Unidades",
      medidas: "",
      material: "",
      color: "",
      precio: "",
      stock: "",
      categoria: "",
      ean: "",
      ref: "",
      proveedor: "",
      nota: "",
      anchoCalc: '',
      altoCalc: '',
      precioCalc:'',
      categoriaSeleccionada: null,
      showForm: false,
      showRelaciones: false,
      relDesdeTabla: false,
      listProductosTitulos: [],
      mapProductoImg: {},
      // Relaciones material / title derivadas de skuMateriales (fuente unica, la usa tambien la Calculadora)
      listRelaciones: [],
      listAllSkuMaterial: [],
      skusPorTitle: {},
      addCantidad: "",
      relMaterialSelect: null,
      relProductoSelect: null,
      addProductoSelect: null,
      stockItem: null,
      stockCantidad: "",
      guardandoStock: false,
      columnasTable: [
        { key: "editar", label: "", thClass: "col-min", tdClass: "col-min" },
        { key: "nombre", label: "Material", sortable: true },
        { key: "color", label: "Color", sortable: true },
        { key: "precio", label: "Precio", sortable: true },
        { key: "stock", label: "Stock", sortable: true, thStyle: { width: "80px" } },
        { key: "categoria", label: "Categoria", sortable: true },
        { key: "proveedor", label: "Proveedor", sortable: true },
        { key: "acciones", label: "", thStyle: { width: "120px" } },
      ],
      linesTable: [],
      listProveedores: [],
      listMateriales: [],
      proveedorSelect: null,
      buscar: "",
      new_img: null,
      new_img_preview: null,
      guardarTrasRecorte: false,
      imgTable: false,
      listTipoMedidas: ["Unidades", "Pie Cuadrado", "Metro cuadrado", "Metro lineal"],
      materialSelected: null,
      materialDuplicado: null,
      updatePrice: true,
      itemInfo: [],
      listCategorias: ["Fidlocks","Imanes","Herrajes","Cremalleras","Cursores","Tintes","Pegamentos","Cintas refuerzo","Fieltro","Microfibra","RPET","Tejidos","Refuerzos","Cuero","Cintas de mochila"]
    }
  },
  computed: {
    categoriasUsadas() {
      const cats = new Set()
      this.listMateriales.forEach(m => {
        if (m.categoria) cats.add(m.categoria)
      })
      return cats.size
    },
    proveedoresUsados() {
      const provs = new Set()
      this.listMateriales.forEach(m => {
        if (m.proveedor && m.proveedor !== '') provs.add(m.proveedor)
      })
      return provs.size
    },
    productosDelMaterial() {
      if (!this.relMaterialSelect) return []
      return this.listRelaciones.filter(rel => rel.idMaterial == this.relMaterialSelect.id)
    },
    materialesDelProducto() {
      if (!this.relProductoSelect) return []
      return this.listRelaciones.filter(rel => rel.tituloProducto == this.relProductoSelect)
    },
    materialesDelProductoInfo() {
      // Solo materiales visibles (los que trae /materiales)
      return this.materialesDelProducto
        .map(rel => ({ rel, mat: this.listMateriales.find(m => m.id == rel.idMaterial) }))
        .filter(item => item.mat)
    },
    stockCantidadValida() {
      const cantidad = parseFloat(String(this.stockCantidad).replace(',', '.'))
      return !isNaN(cantidad) && cantidad !== 0
    },
    stockNuevo() {
      if (!this.stockItem) return 0
      const cantidad = parseFloat(String(this.stockCantidad).replace(',', '.'))
      const total = this.stockNum(this.stockItem) + (isNaN(cantidad) ? 0 : cantidad)
      return Math.round(total * 100) / 100
    },
    resultadoCalc() {
      const ancho = parseFloat(String(this.anchoCalc).replace(',', '.'));
      const alto = parseFloat(String(this.altoCalc).replace(',', '.'));
      const precioTotal = parseFloat(String(this.precioCalc).replace(',', '.'));
      if (!(ancho > 0) || !(alto > 0) || isNaN(precioTotal)) return null;

      const medidas = Math.round(ancho * alto * 10000) / 10000;
      return { medidas, precio: Math.round(precioTotal / medidas * 100) / 100 };
    },
    unidadCalc() {
      return { 'Metro cuadrado': 'metros', 'Metro lineal': 'metros', 'Pie Cuadrado': 'pies' }[this.tipoMedidas] || ''
    },
    notaCalc() {
      const comun = '<br><strong>Medidas</strong> = cuanto material trae una pieza de las que compras. '
        + '<strong>Precio</strong> = lo que cuesta cada unidad de medida, no la pieza entera. '
        + 'El <strong>stock</strong> se cuenta en piezas: la Calculadora de pedidos hace stock x medidas para saber el material disponible '
        + 'y necesario / medidas (redondeando arriba) para saber cuantas piezas pedir. Si medidas esta mal, salen mal el stock y lo que hay que pedir.'
      const notas = {
        'Metro cuadrado': 'Pon ancho y alto de la plancha o rollo <strong>en metros</strong> (ej: 1,5 x 1,2 = <strong>1,8 m²</strong>) y lo que cuesta entera. Precio queda en <strong>€/m²</strong> y la cantidad por SKU va en m².' + comun,
        'Pie Cuadrado': 'Pon ancho y alto de la piel <strong>en pies</strong> (o pon los pies² de la piel en ancho y un 1 en alto) y lo que cuesta entera. Precio queda en <strong>€/pie²</strong> y la cantidad por SKU va en pies².' + comun,
        'Metro lineal': 'Pon el largo del rollo <strong>en metros</strong> (ej: rollo de 50 m = <strong>50</strong>), un <strong>1</strong> en ancho y lo que cuesta el rollo entero. Precio queda en <strong>€/metro</strong> y la cantidad por SKU va en metros.' + comun,
      }
      return notas[this.tipoMedidas] || ''
    },
    productosDisponibles() {
      const usados = this.productosDelMaterial.map(rel => rel.tituloProducto)
      // Solo titles con SKUs: la relacion se guarda en cada SKU
      return this.listProductosTitulos.filter(titulo => !usados.includes(titulo) && this.skusPorTitle[titulo])
    }
  },
  methods:{
    toggleFormulario() {
      if (this.showForm) {
        this.limpiarFormulario()
      }
      this.showForm = !this.showForm
    },
    load(){
      axios.post("/uso", {seccion:"materiales"});
      axios
        .get("/materiales", { params: { sinImg: 1 } })
        .then(response => {
            return response.data;
        })
        .then(res => {
          prepararSinImagen(res);
          this.listMateriales = res;
          this.linesTable = res;
          // Las fotos llegan despues, por lotes, sin bloquear la tabla
          cargarImagenesMateriales(this.listMateriales);
        });

      axios
        .get("/proveedores")
        .then(response => {
            return response.data;
        })
        .then(res => {
          this.listProveedores = res;
        });

      axios
        .get("/articulos/products")
        .then(response => {
            return response.data;
        })
        .then(res => {
          const titulos = new Set()
          const imgs = {}
          res.forEach(p => {
            if (p.title) {
              titulos.add(p.title)
              if (p.image && !imgs[p.title]) imgs[p.title] = p.image
            }
          })
          this.listProductosTitulos = Array.from(titulos).sort()
          this.mapProductoImg = imgs
        });

      this.loadRelaciones();
    },
    loadRelaciones(){
      Promise.all([
        axios.get("/materiales/sku").then(response => response.data),
        axios.get("/articulos/variants").then(response => response.data),
      ]).then(([skuMateriales, variants]) => {
        this.listAllSkuMaterial = skuMateriales;

        const skus = {};
        variants.forEach(v => {
          if (!v.productTitle) return;
          if (!skus[v.productTitle]) skus[v.productTitle] = [];
          skus[v.productTitle].push(v.sku);
        });
        this.skusPorTitle = skus;

        this.construirRelaciones();
      });
    },
    construirRelaciones(){
      // Agrupa skuMateriales por (material, title)
      const titlePorSku = {};
      Object.keys(this.skusPorTitle).forEach(titulo => {
        this.skusPorTitle[titulo].forEach(sku => { titlePorSku[sku] = titulo; });
      });

      const grupos = {};
      this.listAllSkuMaterial.forEach(fila => {
        const titulo = titlePorSku[fila.sku];
        if (!titulo) return;
        const key = fila.idMaterial + "|" + titulo;
        if (!grupos[key])
          grupos[key] = { id: key, idMaterial: fila.idMaterial, tituloProducto: titulo, filas: [] };
        grupos[key].filas.push(fila);
      });
      this.listRelaciones = Object.values(grupos).sort((a, b) => a.tituloProducto.localeCompare(b.tituloProducto));
    },
    textoRelacion(rel){
      const total = (this.skusPorTitle[rel.tituloProducto] || []).length;
      const cantidades = [...new Set(rel.filas.map(f => f.cantidad))];
      const cantidad = cantidades.length === 1 ? cantidades[0] + " ud" : "cantidad variable";
      return rel.filas.length + "/" + total + " SKUs · " + cantidad;
    },
    focusCantidadRel(){
      this.addCantidad = "";
      this.$nextTick(() => this.$refs.inputCantidadRel && this.$refs.inputCantidadRel.focus());
    },
    toggleRelaciones(){
      if (this.showRelaciones && !this.relDesdeTabla) {
        this.cerrarRelaciones()
        return
      }
      this.relDesdeTabla = false
      this.relMaterialSelect = null
      this.relProductoSelect = null
      this.showRelaciones = true
    },
    verRelaciones(data){
      this.relDesdeTabla = true
      this.relProductoSelect = null
      this.relMaterialSelect = data
      this.showRelaciones = true
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    cerrarRelaciones(){
      this.showRelaciones = false
      this.relDesdeTabla = false
      this.relMaterialSelect = null
      this.relProductoSelect = null
    },
    productosDeMaterial(mat){
      if (!mat || !mat.id) return []
      return this.listRelaciones.filter(rel => rel.idMaterial == mat.id)
    },
    asociarRelacion(){
      if (!this.relMaterialSelect || !this.addProductoSelect || !this.addCantidad) return

      // Se guarda individualmente en cada SKU del title, saltando los que ya lo tienen
      const idMaterial = this.relMaterialSelect.id
      const cantidad = this.addCantidad
      const peticiones = []
      ;(this.skusPorTitle[this.addProductoSelect] || []).forEach(sku => {
        const existe = this.listAllSkuMaterial.some(x => x.sku === sku && x.idMaterial == idMaterial)
        if (existe) return
        peticiones.push(
          axios
            .post("/materiales/sku", { sku: sku, idMaterial: idMaterial, cantidad: cantidad })
            .then(res => {
              this.listAllSkuMaterial.push({ id: res.data.insertId, sku: sku, idMaterial: idMaterial, cantidad: cantidad })
            })
        )
      })

      Promise.all(peticiones).then(() => {
        this.addProductoSelect = null
        this.addCantidad = ""
        this.construirRelaciones()
      })
    },
    eliminarRelacion(rel){
      // Quita el material de todos los SKU del title
      const peticiones = rel.filas.map(fila =>
        axios
          .post("/materiales/sku/delete", { id: fila.id })
          .then(() => {
            const index = this.listAllSkuMaterial.findIndex(x => x.id === fila.id)
            if (index > -1) this.listAllSkuMaterial.splice(index, 1)
          })
      )
      Promise.all(peticiones).then(() => this.construirRelaciones())
    },
    guardarMaterial(){
      let idProveedorPrincipal = 1;
      if(this.proveedorSelect != null)
        idProveedorPrincipal = this.proveedorSelect.id

      let info = {
          nombre: this.nombre,
          medidas: this.medidas,
          tipoMedidas: this.tipoMedidas,
          material: this.material,
          color: this.color,
          precio: this.precio,
          stock: this.stock,
          categoria: this.categoria,
          ean: this.ean,
          ref: this.ref,
          idProveedorPrincipal,
          img: this.new_img_preview,
          nota: this.nota,
          anchoCalc: this.anchoCalc,
          altoCalc: this.altoCalc,
          precioCalc: this.precioCalc
      }

      if(this.tipoMedidas == "Unidades")
        info.medidas = "1";

      // Para la tabla y el buscador, igual que lo devuelve GET /materiales
      info.proveedor = this.proveedorSelect ? this.proveedorSelect.nombre : "";
      info.emailProveedor = this.proveedorSelect ? this.proveedorSelect.email : "";

      if(this.materialSelected == null)
      {
        axios
          .post("/materiales", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            info.id = res.insertId;
            this.listMateriales.unshift(info);
            this.limpiarFormulario();
            this.buscarFuncion();
            this.showForm = false;

            this.anchoCalc = "";
            this.altoCalc = "";
            this.precioCalc = "";
          });
      }
      else
      {
        info.id = this.materialSelected.id;

        // /materiales/update no guarda el stock: si ha cambiado se actualiza aparte
        info.stock = this.stockNum(info);
        // Con unidades de almacén el stock no se toca desde aqui
        if (this.tieneUnidades(this.materialSelected))
          info.stock = this.stockNum(this.materialSelected);
        const stockCambiado = info.stock !== this.stockNum(this.materialSelected);

        axios
          .post("/materiales/update", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            if (stockCambiado)
              return axios.post("/materiales/stock/update", { stock: info.stock, id: info.id });
          })
          .then(res => {
            this.listMateriales.forEach(prov => {
              if(prov.id == info.id)
              {
                prov.nombre = info.nombre;
                prov.medidas = info.medidas;
                prov.tipoMedidas = info.tipoMedidas;
                prov.material = info.material;
                prov.color = info.color;
                prov.precio = info.precio;
                prov.categoria = info.categoria;
                prov.ean = info.ean;
                prov.ref = info.ref;
                prov.idProveedorPrincipal = info.idProveedorPrincipal;
                prov.proveedor = info.proveedor;
                prov.emailProveedor = info.emailProveedor;
                prov.img = info.img;
                prov.nota = info.nota;
                prov.stock = info.stock;
                prov.anchoCalc = info.anchoCalc;
                prov.altoCalc = info.altoCalc;
                prov.precioCalc = info.precioCalc;
              }
            });

            this.linesTable.forEach(prov => {
              if(prov.id == info.id)
              {
                prov.nombre = info.nombre;
                prov.medidas = info.medidas;
                prov.tipoMedidas = info.tipoMedidas;
                prov.material = info.material;
                prov.color = info.color;
                prov.precio = info.precio;
                prov.categoria = info.categoria;
                prov.ean = info.ean;
                prov.ref = info.ref;
                prov.idProveedorPrincipal = info.idProveedorPrincipal;
                prov.proveedor = info.proveedor;
                prov.emailProveedor = info.emailProveedor;
                prov.img = info.img;
                prov.nota = info.nota;
                prov.stock = info.stock;
                prov.anchoCalc = info.anchoCalc;
                prov.altoCalc = info.altoCalc;
                prov.precioCalc = info.precioCalc;
              }
            });

            this.limpiarFormulario();
            this.showForm = false;
            this.$bvToast.toast("Material actualizado", { title: "Guardado", variant: "success", solid: true });
          })
          .catch(e => {
            console.error(e);
            this.$bvToast.toast("No se ha podido guardar el material", { title: "Error", variant: "danger", solid: true });
          });
      }
    },
    // Abre el formulario como material nuevo con los datos del original; no se crea hasta darle a Guardar
    duplicarMaterial(data){
      this.editarProveedor(data);
      this.materialSelected = null;
      this.materialDuplicado = data;
      this.nombre = data.nombre + " (copia)";
      this.stock = 0;
    },
    editarProveedor(data){
      this.materialDuplicado = null;
      this.updatePrice = false;
      // Datos guardados de la calculadora (NULL -> vacio)
      this.anchoCalc = data.anchoCalc != null ? String(Number(data.anchoCalc)) : "";
      this.altoCalc = data.altoCalc != null ? String(Number(data.altoCalc)) : "";
      this.precioCalc = data.precioCalc != null ? String(Number(data.precioCalc)) : "";

      setTimeout(()=>{this.updatePrice = true;}, 1000);

      this.nombre = data.nombre;
      this.medidas = data.medidas;
      this.tipoMedidas = data.tipoMedidas;
      this.material = data.material;
      this.color = data.color;
      this.precio = data.precio;
      this.stock = this.stockNum(data);
      this.categoria = data.categoria;
      this.ean = data.ean;
      this.ref = data.ref;
      this.new_img_preview = data.img;
      // Las fotos cargan en segundo plano por lotes: si la de este material aun no ha llegado, se pide ya
      if (!data.img) {
        axios
          .get("/materiales/imagenes", { params: { ids: data.id } })
          .then(response => {
            const fila = (response.data || [])[0];
            if (!fila || !fila.img) return;
            data.img = fila.img;
            // Solo si sigue en el mismo material y no ha subido otra imagen mientras tanto
            if ((this.materialSelected === data || this.materialDuplicado === data) && !this.new_img_preview)
              this.new_img_preview = fila.img;
          });
      }
      this.nota = data.nota;

      this.listProveedores.forEach(prov => {
        if(prov.id == data.idProveedorPrincipal)
          this.proveedorSelect = prov;
      });

      if(data.idProveedorPrincipal == 1)
        this.proveedorSelect = null;

      this.materialSelected = data;
      this.showForm = true;

      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    stockNum(mat){
      const n = parseFloat(mat && mat.stock)
      return isNaN(n) ? 0 : n
    },
    tieneUnidades(mat){
      return !!mat && Number(mat.unidadesAlmacen) > 0
    },
    abrirAgregarStock(data){
      if (this.tieneUnidades(data)) return
      this.stockItem = data
      this.stockCantidad = ""
      this.$refs['modal-agregar-stock'].show()
    },
    guardarAgregarStock(){
      if (!this.stockItem || !this.stockCantidadValida || this.guardandoStock) return

      const item = this.stockItem
      const nuevoStock = this.stockNuevo
      this.guardandoStock = true

      axios
        .post("/materiales/stock/update", { stock: nuevoStock, id: item.id })
        .then(response => {
            return response.data;
        })
        .then(res => {
          this.listMateriales.forEach(mat => {
            if (mat.id == item.id) mat.stock = nuevoStock
          })
          this.$refs['modal-agregar-stock'].hide()
          this.$swal({
            icon: 'success',
            title: 'Stock actualizado',
            text: `${item.nombre}: ${nuevoStock}`,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
        .catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo actualizar el stock',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          })
        })
        .finally(() => {
          this.guardandoStock = false
        });
    },
    verInformacion(data)
    {
      this.itemInfo = data;
      this.$refs['modal-ver-material'].show();
    },
    buscarFuncion(){
      const texto = this.buscar.toLowerCase();

      // Campos nulos (materiales recien creados, columnas vacias) no deben romper la busqueda
      this.linesTable = this.listMateriales.filter(mat => {
        if(this.categoriaSeleccionada != null && mat.categoria != this.categoriaSeleccionada)
          return false;
        return [mat.nombre, mat.color, mat.material, mat.ean, mat.ref, mat.proveedor]
          .some(campo => (campo || '').toString().toLowerCase().includes(texto));
      });
    },
    abrirRecorte(guardarAlAcabar = false){
      this.guardarTrasRecorte = guardarAlAcabar;
      this.$refs.cropper.open(this.new_img_preview);
    },
    recortado(img){
      this.new_img_preview = img;
      // Desde el detalle no hay que pasar por "Actualizar": se guarda al confirmar el recorte
      if (this.guardarTrasRecorte) {
        this.guardarTrasRecorte = false;
        this.guardarMaterial();
      }
    },
    // Desde el detalle: abre el formulario de edicion con el recortador y guarda al recortar
    recortarGuardada(item){
      this.$refs['modal-ver-material'].hide();
      this.editarProveedor(item);
      this.$nextTick(() => this.abrirRecorte(true));
    },
    limpiarFormulario(){
        this.materialDuplicado = null;
        this.nombre = "";
        this.medidas = "";
        this.tipoMedidas = "Unidades";
        this.material = "";
        this.color = "";
        this.precio = "";
        this.stock = "";
        this.categoria = "";
        this.ean = "";
        this.ref = "";
        this.proveedorSelect = null;
        this.new_img_preview = "";
        this.nota = "";
        this.materialSelected = null;

        this.updatePrice = false;
        this.anchoCalc = "";
        this.altoCalc = "";
        this.precioCalc = "";
        setTimeout(()=>{this.updatePrice = true;}, 1000);
    },
    confirmText(data) {
      this.$swal({
        title: 'Eliminar material',
        text: `Se eliminara "${data.nombre}".`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-outline-danger eliminar-btn',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios
            .post("/materiales/delete", {id: data.id})
            .then(response => {
                return response.data;
            })
            .then(res => {
              let index = this.listMateriales.findIndex(x => x.id === data.id);
              if (index > -1) {
                this.listMateriales.splice(index, 1);
              }

              let indexTable = this.linesTable.findIndex(x => x.id === data.id);
              if (indexTable > -1) {
                this.linesTable.splice(indexTable, 1);
              }

              this.$swal({
                icon: 'success',
                title: 'Eliminado',
                text: 'El material ha sido eliminado',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            });
        }
      })
    },
    // Se aplica solo con el boton: antes iba con watchers y pisaba medidas/precio mientras se escribia
    calcular(){
      if(!this.resultadoCalc) return;
      this.medidas = this.resultadoCalc.medidas;
      this.precio = this.resultadoCalc.precio;
    }
  },
  watch: {
    relMaterialSelect(val){
      if (val != null) {
        this.relProductoSelect = null
      }
      this.addProductoSelect = null
    },
    relProductoSelect(val){
      if (val != null) {
        this.relMaterialSelect = null
      }
    },
    buscar(){
      this.buscarFuncion();
    },
    categoriaSeleccionada(){
      this.buscarFuncion();
    },
    new_img() {
      let self = this;
      if(this.new_img != null)
      {
        let tamanyo = ((this.new_img.size/1024)/1024).toFixed(4);
        // El recorte reduce la imagen a max 1200px, asi que se admiten originales mas grandes
        if(tamanyo < 15)
        {
          const file = this.new_img;
          var reader = new FileReader();
          reader.onloadend = function() {
            self.$refs.cropper.open(reader.result, file.type);
          }
          reader.readAsDataURL(file);
        }
        else
        {
          self.$bvToast.toast("La imagen ocupa más de 15MB", { title: "Error", variant: "danger", solid: true });
        }
        // Permite volver a elegir el mismo archivo
        this.new_img = null;
      }
    },
    imgTable(){
      if(this.imgTable)
      {
        // Justo despues de la columna de editar
        this.columnasTable.splice(1, 0, {
          key: "img",
          label: "Img",
          sortable: false,
          thStyle: { width: "80px" },
        })
      }
      else
      {
        const index = this.columnasTable.findIndex(col => col.key === "img");
        if (index > -1) this.columnasTable.splice(index, 1);
      }
    },
  },
  mounted() {
    this.load();
  }
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$info: #06B6D4;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.materiales-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 8px;
}

// Header
.mat-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
}

.header-eyebrow {
  display: block;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: $primary;
  margin-bottom: 2px;
}

.header-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: $text;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 8px;
}

// Buttons
.btn-mat {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: $radius-sm;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &--primary {
    background: $primary;
    color: white;
    &:hover { background: $primary-dark; }
  }

  &--warning {
    background: $warning;
    color: white;
    &:hover { background: darken($warning, 8%); }
  }

  &--ghost {
    background: transparent;
    color: $text-muted;
    border: 1px solid $border;
    &:hover { background: $bg; color: $text; }
  }
}

// KPI Strip
.kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.kpi-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius-sm;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  box-shadow: $shadow;
}

.kpi-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
}

.kpi-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 700;
  color: $text;
  font-feature-settings: "tnum";
  margin: 4px 0 2px;
}

.kpi-foot {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: $text-muted;
}

// Form Card
.form-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  margin-bottom: 20px;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 22px 24px 0;
  }

  &__icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;

    &--primary { background: rgba($primary, 0.1); color: $primary; }
    &--warning { background: rgba($warning, 0.1); color: $warning; }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $text;
    margin: 0;
  }

  &__subtitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: $text-muted;
    margin: 2px 0 0;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 24px 20px;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  padding: 20px 24px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &--span2 { grid-column: span 2; }
  &--span3 { grid-column: span 3; }

  &__label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: $text-muted;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__input {
    border-radius: 8px !important;
    border: 1px solid $border !important;
    font-size: 13px !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      border-color: $primary !important;
      box-shadow: 0 0 0 3px rgba($primary, 0.1) !important;
    }
  }
}

// Upload area
.upload-area {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  border: 2px dashed $border;
  border-radius: $radius-sm;
  cursor: pointer;
  transition: all 0.15s ease;
  overflow: hidden;

  &:hover {
    border-color: $primary;
    background: rgba($primary, 0.02);
  }

  &__input { display: none; }

  // Con imagen se agranda y se ve entera (contain), sin recortar
  &--con-img {
    height: 160px;
    border-style: solid;
    padding: 6px;
  }

  &__preview {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: $text-muted;
    font-size: 11px;
    font-family: 'JetBrains Mono', monospace;

    i { font-size: 18px; }
  }
}

.field__hint {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: $text-muted;
}

.action-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.upload-crop {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
  padding: 3px 10px;
  border-radius: 6px;
  border: 1px solid $border;
  background: transparent;
  color: $text-muted;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    border-color: $primary;
    color: $primary;
  }
}

// Calculator bar
.calc-bar {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  padding: 0 24px 16px;
  margin-top: -4px;

  &__label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 600;
    color: $primary;
    white-space: nowrap;
    padding-bottom: 8px;

    i { margin-right: 4px; }
  }

  &__fields {
    display: flex;
    gap: 12px;
  }

  &__fields {
    align-items: flex-end;
  }

  &__result {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: $text;
    white-space: nowrap;
    padding-bottom: 8px;
  }

  &__unit {
    text-transform: none;
    letter-spacing: 0;
    font-weight: 400;
    color: #94A3B8;
  }
}

.calc-note {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: -6px 24px 16px;
  padding: 8px 12px;
  border-radius: $radius-sm;
  background: rgba($primary, 0.06);
  font-size: 12px;
  line-height: 1.5;
  color: $text-muted;

  i { color: $primary; margin-top: 3px; }
  strong { color: $text; }
}

// Relaciones material / producto
.form-card--rel {
  overflow: visible; // que el desplegable del v-select no se recorte
}

.form-grid--rel {
  padding-bottom: 8px;
}

.rel-body {
  padding: 0 24px 22px;

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    color: $text;
    margin-bottom: 12px;

    strong { font-weight: 700; }
  }
}

.rel-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  margin-left: 6px;
  border-radius: 11px;
  background: rgba($primary, 0.1);
  color: $primary;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 700;
}

.rel-close {
  width: 24px;
  height: 24px;
  margin-left: 8px;
  border-radius: 50%;
  border: 1px solid $border;
  background: transparent;
  color: $text-muted;
  cursor: pointer;
  font-size: 11px;
  transition: all 0.15s ease;

  &:hover {
    background: rgba($danger, 0.08);
    color: $danger;
    border-color: rgba($danger, 0.2);
  }
}

.rel-add {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;

  &__select {
    flex: 1;
    max-width: 420px;
  }

  &__qty {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__qty-input {
    width: 100px;
    padding: 7px 10px;
    border: 1px solid $border;
    border-radius: $radius-sm;
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
    font-weight: 700;
    text-align: center;
    color: $text;
    background: transparent;

    &:focus { outline: none; border-color: $primary; }
  }

  &__unit, &__hint {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: $text-muted;
    white-space: nowrap;
  }
}

.rel-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.rel-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 10px;
}

.rel-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid $border;
  border-radius: $radius-sm;
  background: $card-bg;
  transition: all 0.15s ease;

  &--clickable {
    cursor: pointer;

    &:hover {
      border-color: rgba($primary, 0.4);
      box-shadow: 0 2px 8px rgba($primary, 0.08);
    }
  }

  &__img {
    width: 44px;
    height: 44px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid $border;
    flex-shrink: 0;

    &--empty {
      display: flex;
      align-items: center;
      justify-content: center;
      border-style: dashed;
      color: #CBD5E1;
      font-size: 14px;
    }
  }

  &__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: $text;
    line-height: 1.25;
  }

  &__sub {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: $text-muted;
    margin-top: 2px;
  }
}

.rel-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 6px 6px 14px;
  border-radius: 20px;
  background: rgba($primary, 0.06);
  border: 1px solid rgba($primary, 0.15);

  &__text {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: $text;
  }

  &__remove {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: $text-muted;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    transition: all 0.15s ease;

    &:hover {
      background: rgba($danger, 0.1);
      color: $danger;
    }
  }
}

.rel-empty {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text-muted;
  margin: 0;
}

.btn-mat--active {
  border-color: $primary !important;
  color: $primary !important;
  background: rgba($primary, 0.06) !important;
}

.badge-cat--rel {
  margin: 2px 4px 2px 0;
}

// Slide transition
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
  max-height: 700px;
  overflow: hidden;
}
.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
}

// List Card
.list-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;

  &__header {
    padding: 20px 22px;
    border-bottom: 1px solid $border;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $text;
    margin: 0 0 14px;
  }

  &__filters {
    display: flex;
    align-items: flex-end;
    gap: 14px;
  }

  &__footer {
    padding: 12px 22px;
    border-top: 1px solid $border;
  }
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: $text-muted;
  margin: 0;
}

.search-box {
  position: relative;
  flex: 1;
  max-width: 300px;

  &__icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: $text-muted;
    font-size: 12px;
  }

  &__input {
    width: 100%;
    padding: 7px 12px 7px 32px;
    border: 1px solid $border;
    border-radius: $radius-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    color: $text;
    background: transparent;
    transition: border-color 0.15s ease;

    &::placeholder { color: #CBD5E1; }
    &:focus { outline: none; border-color: $primary; }
  }
}

// Table
.table-wrapper {
  padding: 0;
}

// Los ::v-deep van bajo .materiales-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.materiales-page ::v-deep .table-head th {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
  border-top: none;
  border-bottom: 1px solid $border;
  padding: 10px 16px;
  background: transparent;
}

.materiales-page ::v-deep .table-row td {
  padding: 10px 16px;
  vertical-align: middle;
  border-color: lighten($border, 3%);
  font-size: 13px;
}

.materiales-page ::v-deep .table-row:hover td {
  background: $bg;
}

// Columna ajustada al contenido (boton editar)
.materiales-page ::v-deep .table-head th.col-min,
.materiales-page ::v-deep .table-row td.col-min {
  width: 1%;
  white-space: nowrap;
  padding-left: 12px;
  padding-right: 0;
}

.cell-img {
  width: 56px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid $border;
}

.cell-img-empty {
  width: 56px;
  height: 40px;
  border-radius: 6px;
  border: 1px dashed $border;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CBD5E1;
  font-size: 14px;
}

.cell-nombre {
  display: flex;
  flex-direction: column;

  &__name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: $text;
    line-height: 1.2;
  }

  &__material {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: $text-muted;
  }
}

.cell-text {
  font-size: 13px;
  color: $text;
}

.cell-mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text;
  font-feature-settings: "tnum";
}

.cell-muted {
  color: #CBD5E1;
  font-size: 12px;
}

.badge-cat {
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 20px;
  background: rgba($primary, 0.08);
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  color: $primary;
}

.cell-actions {
  display: flex;
  gap: 4px;
}

.action-btn {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: $text-muted;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  font-size: 12px;

  &--view:hover {
    background: rgba($info, 0.1);
    color: $info;
    border-color: rgba($info, 0.2);
  }

  &--edit:hover {
    background: rgba($primary, 0.1);
    color: $primary;
    border-color: rgba($primary, 0.2);
  }

  &--delete:hover {
    background: rgba($danger, 0.1);
    color: $danger;
    border-color: rgba($danger, 0.2);
  }

  &--copy:hover {
    background: rgba($primary, 0.1);
    color: $primary;
    border-color: rgba($primary, 0.2);
  }

  &--link:hover {
    background: rgba($success, 0.1);
    color: $success;
    border-color: rgba($success, 0.2);
  }

  &--stock:hover {
    background: rgba($warning, 0.1);
    color: $warning;
    border-color: rgba($warning, 0.2);
  }
}

.cell-stock--empty {
  color: $danger;
}

.footer-count {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text-muted;
}

// Responsive
@media (max-width: 768px) {
  .kpi-strip { grid-template-columns: repeat(2, 1fr); }
  .form-grid { grid-template-columns: 1fr 1fr; }
  .field--span2 { grid-column: span 2; }
  .field--span3 { grid-column: span 2; }
  .mat-header { flex-direction: column; align-items: flex-start; gap: 12px; }
  .list-card__filters { flex-direction: column; align-items: stretch; }
  .search-box { max-width: none; }
  .calc-bar { flex-direction: column; align-items: flex-start; }
  .header-actions { width: 100%; }
}

@media (max-width: 480px) {
  .form-grid { grid-template-columns: 1fr; }
  .field--span2, .field--span3 { grid-column: span 1; }
}
</style>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

// Vue-select (unscoped)
.materiales-page {
  .select-styled {
    .vs__dropdown-toggle {
      min-height: 31px;
      padding: 0 0 2px 0;
      border-radius: 8px;
      border: 1px solid #E2E8F0;
      transition: border-color 0.15s ease;
    }

    .vs__search {
      font-size: 13px;
      font-family: 'Plus Jakarta Sans', sans-serif;
    }

    &.vs--open .vs__dropdown-toggle {
      border-color: #3B82F6;
      box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1);
    }
  }

  .select-filter {
    min-width: 180px;
  }
}

.eliminar-btn {
  color: white !important;
}

// Modal
.modal-mat {
  .modal-content {
    border-radius: 16px;
    border: 1px solid #E2E8F0;
    box-shadow: 0 20px 60px rgba(0,0,0,0.12), 0 8px 20px rgba(0,0,0,0.06);
    overflow: hidden;
  }

  .modal-body {
    padding: 0;
  }
}

.modal-custom {
  &__header {
    text-align: center;
    padding: 28px 28px 0;
  }

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    font-size: 18px;

    &--primary { background: rgba(#3B82F6, 0.1); color: #3B82F6; }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #1E293B;
    margin: 0 0 4px;
  }

  &__subtitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: #64748B;
    margin: 0;
  }

  &__body {
    padding: 22px 28px;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 28px 24px;
  }
}

.modal-img {
  position: relative;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E8F0;

  .upload-crop--floating {
    position: absolute;
    right: 8px;
    bottom: 8px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    border-radius: 6px;
    border: 1px solid #E2E8F0;
    background: rgba(255, 255, 255, 0.92);
    color: #64748B;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;

    &:hover { border-color: #3B82F6; color: #3B82F6; }
  }

  &__image {
    width: 100%;
    height: 220px;
    object-fit: contain; // se ve el recorte entero, no otro recorte al ancho del modal
    background: #F8FAFC;
    display: block;
  }
}

.detail-grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  transition: background 0.1s ease;

  &:hover { background: #F8FAFC; }

  &__icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: #F1F5F9;
    color: #64748B;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    flex-shrink: 0;
    margin-top: 1px;
  }

  &__label {
    display: block;
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #94A3B8;
    line-height: 1;
    margin-bottom: 3px;
  }

  &__value {
    display: block;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #1E293B;
    line-height: 1.3;
    word-break: break-all;

    &--mono {
      font-family: 'JetBrains Mono', monospace;
      font-size: 13px;
      font-feature-settings: "tnum";
    }
  }
}

// Modal agregar stock
.stock-summary {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;

  &__col {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  &__value {
    font-family: 'JetBrains Mono', monospace;
    font-size: 20px;
    font-weight: 700;
    color: #1E293B;
    font-feature-settings: "tnum";
    line-height: 31px;

    &--new { color: #10B981; }
  }

  &__input {
    text-align: center;
    border-radius: 8px !important;
    font-family: 'JetBrains Mono', monospace;
  }

  &__op {
    color: #94A3B8;
    font-size: 12px;
    padding-bottom: 10px;
  }
}

// Productos del material en el modal de detalle
.modal-prod {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 0;

  &__img {
    width: 34px;
    height: 34px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #E2E8F0;
    flex-shrink: 0;

    &--empty {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-style: dashed;
      color: #CBD5E1;
      font-size: 12px;
    }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #1E293B;
    line-height: 1.25;
    word-break: normal;
  }
}

.btn-modal {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 8px;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &--primary {
    background: #3B82F6;
    color: white;
    &:hover { background: #2563EB; }
  }

  &--ghost {
    background: transparent;
    color: #64748B;
    &:hover { background: #F1F5F9; color: #1E293B; }
  }
}

// Dark mode
.dark-layout {
  .materiales-page {
    .header-title { color: #E2E8F0; }

    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .form-card { background: #1E293B; border-color: #334155; }
    .form-card__title { color: #E2E8F0; }
    .field__label { color: #94A3B8; }
    .field__input {
      background: #0F172A !important;
      border-color: #334155 !important;
      color: #E2E8F0 !important;
      &:focus { border-color: #3B82F6 !important; }
    }

    .upload-area {
      border-color: #334155;
      &:hover { border-color: #3B82F6; }
    }

    .calc-bar__label { color: #60A5FA; }
    .calc-note { background: rgba(#3B82F6, 0.1); color: #94A3B8; strong { color: #E2E8F0; } }

    .rel-body__title { color: #E2E8F0; }
    .rel-chip {
      background: rgba(#3B82F6, 0.12);
      border-color: rgba(#3B82F6, 0.25);
      &__text { color: #E2E8F0; }
    }
    .rel-add__qty-input { border-color: #334155; color: #E2E8F0; }

    .rel-card {
      background: #0F172A;
      border-color: #334155;
      &__title { color: #E2E8F0; }
      &__img { border-color: #334155; }
      &__img--empty { color: #475569; }
    }
    .rel-close { border-color: #475569; color: #94A3B8; }

    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }

    .search-box__input {
      border-color: #334155;
      color: #E2E8F0;
      &::placeholder { color: #475569; }
      &:focus { border-color: #3B82F6; }
    }

    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row td { border-color: #334155; }
    .table-row:hover td { background: rgba(255,255,255,0.03); }

    .cell-nombre__name { color: #E2E8F0; }
    .cell-text { color: #E2E8F0; }
    .cell-mono { color: #E2E8F0; }
    .cell-img { border-color: #334155; }
    .cell-img-empty { border-color: #334155; color: #475569; }
    .action-btn { color: #94A3B8; }

    .btn-mat--ghost { border-color: #475569; color: #94A3B8; &:hover { background: #334155; color: #E2E8F0; } }

    .select-styled {
      .vs__dropdown-toggle { border-color: #334155; background: #0F172A; }
      .vs__search { color: #E2E8F0; }
    }
  }

  .modal-mat .modal-content { background: #1E293B; border-color: #334155; }
  .modal-custom__title { color: #E2E8F0; }
  .modal-img { border-color: #334155; }
  .detail-item:hover { background: rgba(255,255,255,0.03); }
  .detail-item__icon { background: #334155; color: #94A3B8; }
  .detail-item__value { color: #E2E8F0; }
  .modal-prod__img { border-color: #334155; }
  .modal-prod__img--empty { color: #475569; }
  .modal-prod__title { color: #E2E8F0; }
  .stock-summary__value { color: #E2E8F0; }
  .stock-summary__value--new { color: #34D399; }
  .stock-summary__input { background: #0F172A; border-color: #334155; color: #E2E8F0; }
}
</style>
